import React from 'react';

import { SkeletonLoader } from 'common/react/components/SkeletonLoader';

/**
 * Displays a loading state for the Ins/Outs section when both teams are requested.
 *
 * @returns The Ins/Outs both teams' skeleton loader.
 */
export const InsOutsBothSkeleton = () => (
    <>
        <div className="u-hide-until-tablet">
            <div className="team-lineups-condensed-embeddable--skeleton team-lineups-condensed-embeddable__ins-and-outs team-lineups-condensed-embeddable__ins-and-outs--both team-lineups-condensed-embeddable__skeleton">
                <div className="team-lineups__grid">
                    <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--home">
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={120} />
                        </div>
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={120} />
                        </div>
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={120} />
                        </div>
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={120} />
                        </div>
                    </div>
                    <div className="team-lineups__title-section u-hide-until-tablet">
                        <div className="team-lineups-ins-and-outs__title-wrapper">
                            <SkeletonLoader width={56} height={24} />
                        </div>
                    </div>
                    <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--away">
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={120} />
                        </div>
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={120} />
                        </div>
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={120} />
                        </div>
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={120} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="u-hide-from-tablet">
            <div className="team-lineups-condensed-embeddable--skeleton team-lineups-condensed-embeddable__ins-and-outs team-lineups-condensed-embeddable__ins-and-outs--both team-lineups-condensed-embeddable__skeleton">
                <div className="team-lineups__title-section u-hide-from-tablet">
                    <div className="team-lineups-ins-and-outs__title-wrapper">
                        <SkeletonLoader width={43} height={20} />
                    </div>
                </div>
                <div className="team-lineups__grid">
                    <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--home">
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={140} />
                        </div>
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={140} />
                        </div>
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={140} />
                        </div>
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={140} />
                        </div>
                    </div>
                    <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--away">
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={140} />
                        </div>
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={140} />
                        </div>
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={140} />
                        </div>
                        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
                            <SkeletonLoader height={36} width={140} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
);
